module.exports = __webpack_public_path__ + "static/media/testfile_ps_crop.27bd2be3.zip";